import React from 'react';
import Link from '../../Link';
import SwitchLocale from '../../Locale/SwitchLocale';
import Search from '../../Icons/Search';
import Gift from '../../Icons/Gift';
import { FormattedMessage } from 'react-intl';
import { aBtesting } from '../../../abtest/abtest'; 


//компонент меню для роли пользователя (включая неавторизованного), содержащий ссылки с правой стороны
const HeaderRightSideUser = ({user, openClaim, onOpenCountrySelect, data, abtest, isLogged, logOut, onOpenSearch, onOpenSigin, openSettings}) => {
    return ( 
        <div className='Header__rightside'>
            {/* <button className='Header__loging-button' onClick={openClaim} >
                <FormattedMessage id='header.become_participant' />
            </button> */}
            <Link to='/persons' onClick={aBtesting(user).send} className='Header__loging-button'>
                Предложить лот
            </Link>
            {abtest
            ?
            <Link to='/help' onClick={aBtesting(user).send} className='Header__loging-button'>
                Поддержать
            </Link>
            :
            <Link to='/help' onClick={aBtesting(user).send} className='Header__loging-button'>
                <FormattedMessage id='support.project' />
            </Link>
            }

            { !data.hideCountry || data.hideCountry === 'undefined'
            ? (<SwitchLocale onClick={onOpenCountrySelect} />)
            : ''
            }
            { isLogged
                ? 
                (<div className='Header__dropdown'>
                    <Link to='/profile' className='Header__loging-button'>{user.name}</Link>
                    <div className='Header__dropdown-list'>
                        <Link to='/profile' className='Header__dropdown-item'>
                            <FormattedMessage id='header.profile' />
                        </Link>
                        {/* <button className='Header__dropdown-item' onClick={openClaim} >
                        <FormattedMessage id='header.become_participant' />
                        </button> */}
                        <button className='Header__dropdown-item' onClick={openSettings}>
                            <FormattedMessage id='header.settings' />
                        </button>
                        <button className='Header__dropdown-item' onClick={logOut}>
                            <FormattedMessage id='header.logout' />
                        </button>
                    </div>
                </div>)
                :
                (<button className='Header__loging-button' onClick={onOpenSigin}>
                    <FormattedMessage id='header.login' />
                </button>)
            }
            {isLogged && (
                <Link to='/giftcards' className='helpBurger'>
                    <span className='Header__giftcard-img'>
                        <Gift className='hoverGift' />
                    </span>
                </Link>
            )}
            <button className='Header__search-button' onClick={onOpenSearch}>
                <span className='Header__search-img'><Search /></span>
            </button>
        </div>
    )
}

export default HeaderRightSideUser;



// WEBPACK FOOTER //
// ./src/components/MenuComponents/menu/HeaderRightSideUser.jsx